<template>
    <information-modal
        :title="state.title"
        key="confirmDialog"
        ref="confirmDialog"
        v-model="state.isOpen"
        :show-footer="true"
        className="confirm">
        {{ state.content }}
        <template v-slot:footer>
            <button
                type="button"
                class="btn btn-secondary"
                data-bs-dismiss="modal"
                @click.prevent="cancel">
                No
            </button>

            <button
                type="button"
                class="btn btn-primary"
                @click.prevent="agree">
                Yes
            </button>
        </template>
    </information-modal>
</template>
<script lang="ts" setup>
import {useConfirmDialog} from "@/composable/useConfirmDialog";
import {InformationModal} from ".";
const {state} = useConfirmDialog();

const agree = () => {
    state.resolve(true);
    state.isOpen = false;
};
const cancel = () => {
    state.resolve(false);
    state.isOpen = false;
};
</script>
